<template>
  <div>
    <mdb-container>
      <mdb-row>
        <mdb-col md="4" class="mb-5 d-flex">
          <mdb-card narrow>
            <mdb-view hover cascade>
              <mdb-card-image :src="require('../assets/images/us/10.jpg')" alt="Card image cap"></mdb-card-image>
              <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
            </mdb-view>
            <mdb-card-body v-animateOnScroll="{animation: 'rotateInUpLeft', delay: 0}" class="text-center" cascade>
              <mdb-card-title><strong>美国</strong></mdb-card-title>
              <h5 class="dark-grey-text"><strong>EB-5投资移民</strong></h5>
              <mdb-card-text>对申请人无学历、语言、年龄要求<br/>对申请人不要求具备任何商业背景<br/>对申请人无资产要求
              </mdb-card-text>
              <mdb-btn color="purple" @click="$router.push('/usa/eb5')">
                <mdb-icon icon="clone" class="left"/>
                查看详情
              </mdb-btn>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>


        <mdb-col md="4" class="mb-5 d-flex">
          <mdb-card narrow>
            <mdb-view hover cascade>
              <mdb-card-image :src="require('../assets/images/us/6.jpg')" alt="Card image cap"></mdb-card-image>
              <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
            </mdb-view>
            <mdb-card-body v-animateOnScroll="{animation: 'rotateInUpLeft', delay: 0}" class="text-center" cascade>
              <mdb-card-title><strong>美国</strong></mdb-card-title>
              <h5 class="dark-grey-text"><strong>L1签证</strong></h5>
              <mdb-card-text>审批速度快，平均审理周期仅4--6个月<br/>美国公司正常运转满一年即可申办EB-1C转绿卡<br/>对申请人的年龄、语言、和资产来源均没有要求
              </mdb-card-text>
              <mdb-btn color="danger" @click="$router.push('/usa/l1')">
                <mdb-icon icon="clone" class="left"/>
                查看详情
              </mdb-btn>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>

  </div>

</template>

<script>
import { animateOnScroll } from 'mdbvue'

export default {
  name: 'HomeUsa',
  directives: {
    animateOnScroll
  }
}
</script>

<style>
.opacityOuterUsa {
  background: rgba(0, 0, 0, 0.1) !important;
  background: #fff;
  filter: Alpha(opacity=10);
}
</style>
